import { Link2 } from 'lucide-react'
import type { ProblemEditorData } from '../problem-editor'
import { ProblemDependenciesSection } from './problem-dependencies-section'
import { SeriesSection } from './series-section'

interface RelationshipsSectionProps {
  formData: ProblemEditorData
}

export function RelationshipsSection({ formData }: RelationshipsSectionProps) {
  return (
    <div className="space-y-8">
      {/* Problem Dependencies Section */}
      <ProblemDependenciesSection formData={formData} />

      {/* Series Section */}
      <SeriesSection formData={formData} />

      {/* Variants Section (Placeholder) */}
      <section>
        <div className="mb-4">
          <h3 className="text-muted-foreground flex items-center gap-2 text-lg font-semibold">
            <Link2 className="h-5 w-5" />
            Company Variants
            <span className="bg-muted rounded px-2 py-0.5 text-xs">
              Coming Soon
            </span>
          </h3>
          <p className="text-muted-foreground mt-1 text-sm">
            Link company-specific variations of this problem.
          </p>
        </div>
        <div className="rounded-lg border border-dashed p-6 text-center opacity-50">
          <p className="text-muted-foreground text-sm">
            Company variant linking will be available soon.
          </p>
        </div>
      </section>
    </div>
  )
}
